import React from "react";
import CultureDropdown from "./CultureDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const CulturesInterfaceDropdown = (props: DropdownWithoutOptionsProps<server.dto.Culture, server.dto.LCID>) => {
  const options = serverReference.interfaceCultures;

  return <CultureDropdown
    excludeKeys={props.excludeKeys}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    options={options}
    config={props.config}
  />;
};

export default CulturesInterfaceDropdown;